import WixEvent from 'ui/events/WixEvent';

/**
 * @callback $w.IconMouseInEventHandler
 * @summary Handles events fired when a user hovers over a star on the rating component.
 * @param {$w.IconMouseInEvent} event The event that occurred.
 */

/**
 * @class IconMouseInEvent
 * @summary Event that is fired when a user hovers over a star on a ratings input component.
 * @memberof $w
 * @mixes $w.Event
 */
export default class IconMouseInEvent extends WixEvent {
    constructor(target, event) {
        super(target, event);

        this.label = event.label;
        this.value = event.value;
    }
}

/**
 * @member {external:String} label
 * @label property
 * @syntax
 * get label(): string
 * @summary Gets the display label that corresponds to the icon that the mouse entered.
 * @snippet [IconMouseInEvent-all.es6=Get information about the icon that the mouse entered]
 * @memberof $w.IconMouseInEvent
 * @readonly
 */

/**
 * @member {external:Number} value
 * @label property
 * @syntax
 * get value(): number
 * @summary Gets the value (1-5) that corresponds to the icon that the mouse entered.
 * @snippet [IconMouseInEvent-all.es6=Get information about the icon that the mouse entered]
 * @memberof $w.IconMouseInEvent
 * @readonly
 */



// WEBPACK FOOTER //
// ./js/modules/ui/events/IconMouseInEvent.es6